import * as React from 'react';
import { DASHBOARD } from '../../../../routes';
import { prependAppPath } from '../../../services/Url';
import { DeprecatedButtonContainer } from '../../ButtonContainer';
import LinkButton from '../../LinkButton';
import styles from './style.m.less';

type Props = {
    illustrationSrc?: string;
    title: React.ReactNode;
    body: React.ReactNode;
};

export const ErrorMessage: React.FC<Props> = ({ illustrationSrc, title, body }) => {
    return (
        <div className={styles.container}>
            {illustrationSrc && <img src={illustrationSrc} alt="" />}
            <div>
                <h1>{title}</h1>
                {body}
                <DeprecatedButtonContainer>
                    <LinkButton kind="PRIMARY" href={prependAppPath(DASHBOARD)}>
                        Return Home
                    </LinkButton>
                </DeprecatedButtonContainer>
            </div>
        </div>
    );
};
